export function getRegionlessLanguage(language: string): string {
  return language.split('-')[0];
}
